
export const NO_PHRASE_HINT = 'Please select a phrase to use a prompt';
